const fuelType = [
  {
    value: 'gasoline',
    label: 'GASOLINE',
  },
  {
    value: 'diesel',
    label: 'DIESEL',
  },
  {
    value: 'electric',
    label: 'ELECTRIC',
  },
  {
    value: 'cng',
    label: 'CNG',
  },
  {
    value: 'lpg',
    label: 'LPG',
  },
  {
    value: 'hydrogen',
    label: 'HYDROGEN',
  },
  {
    value: 'hybrid',
    label: 'HYBRID',
  },
];

export default fuelType;
